/* eslint-disable */
import { notificationServices } from '@/Services';
import moment from 'moment';
import { useAnalysisStore } from '../AssetAnalysisStore';
import { DatePicker, DateRangePicker } from 'rsuite';
export const getAnalysisType = (activeAnalysisTab, state) => {
	let obj = {};
	if (activeAnalysisTab === 'quantitative') {
		obj = {
			tabType: 'quantitative',
		};
	}
	if (activeAnalysisTab === 'utilization') {
		obj = {
			tabType: 'utilization',
		};
	}
	if (activeAnalysisTab === 'maintenance') {
		obj = {
			tabType: 'maintenance',
		};
	}
	obj.analysisSubType = state?.activeQCType;
	return obj;
};

export const getGroupingType = (activeGroupingType, state) => {
	let obj = {};
	if (activeGroupingType === 'assetGroupWise') {
		const { assetWiseDropdown } = state;
		const activeProduct = assetWiseDropdown.find((item) => item.active);
		obj = {
			dateRangeFilter: {
				from:
					moment(state.dateRangeObj?.from).format('YYYY-MM-DD') ||
					null,
				to: moment(state.dateRangeObj?.to).format('YYYY-MM-DD') || null,
			},
			grouping: {
				active: true,
				type: 'assetGroupWise',
				currentSelection: activeProduct.key,
				selection: {
					assetCategory: state?.chartSelectionObj?.category ?? null,
					assetType: state?.chartSelectionObj?.subCategory ?? null,
				},
			},
		};
	}
	if (activeGroupingType === 'geography') {
		const { geographyWiseDropdown } = state;
		const activeGeography = geographyWiseDropdown.find(
			(item) => item.active
		);
		obj = {
			dateRangeFilter: {
				from:
					moment(state.dateRangeObj?.from).format('YYYY-MM-DD') ||
					null,
				to: moment(state.dateRangeObj?.to).format('YYYY-MM-DD') || null,
			},
			grouping: {
				active: true,
				type: 'geographyWise',
				currentSelection: activeGeography.key,
				selection: {
					region: state?.chartSelectionObj?.region ?? null,
					city: state?.chartSelectionObj?.city ?? null,
				},
			},
		};
	}
	if (activeGroupingType === 'time') {
		const { timeRangesDropdown } = state;
		const { year, month, day, quarter, week, period } =
			state.dateInfo || {};
		const activeTimeRange = timeRangesDropdown.find((item) => item.active);
		obj = {
			grouping: {
				active: true,
				type: 'periodWise',
				currentSelection: activeTimeRange.key,
				selection: {
					year: year ?? null,
					month: month ?? null,
					day: day ?? null,
					quarter: quarter ?? null,
				},
			},
		};
	}
	return obj;
};